// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"73cab83f95a5d3458d23","655":"9595123626626f9b9bf0"}[chunkId] + ".js";
};